import {useLocation} from "react-router-dom";
import {SubscriptionQuery} from "../models/SubscriptionQuery";


export function GetSubscriptionQuery(queryType: SubscriptionQuery) {
        const useQuery = () =>  new URLSearchParams(useLocation().search)
        const query = useQuery()
        const result = query.get(queryType)
        return result
}